import axios from '../service/axios/axios'

export default {
  // 获取医生信息列表
  doctorList(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/doctorList',
      data,
    })
  },
  // 设置医生标签
  setDoctorServiceLabel(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/setDoctorServiceLabel',
      data,
    })
  },
  // 患者信息列表
  patientList(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/patientList',
      data,
    })
  },
  // 设置患者标签
  setPatientServiceLabel(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/setPatientServiceLabel',
      data,
    })
  },
  // 日常工作统计列表
  getDailyWorkData(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/getDailyWorkData',
      data,
    })
  },
  // 导出日常工作统计列表
  exportDailyWorkData(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/exportDailyWorkData',
      data,
    })
  },
  /** 待办事项---start */
  // 获取待办事项列表
  getTodoList(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/getTodoList',
      data,
    })
  },
  // 添加事项
  addTodo(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/addTodo',
      data,
    })
  },
  // 处理事项
  handleTodo(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/handleTodo',
      data,
    })
  },
  // 获取订单跳转路由
  getTodoOrderRoute(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/getTodoOrderRoute',
      data,
    })
  },
  /** 待办事项---end */
  // 发货统计列表
  hospitalSend(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/hospitalSend',
      data,
    })
  },
  // 导出发货统计
  exportHospitalSend(data) {
    return axios({
      method: 'post',
      url: 'platform/Clientreview/exportHospitalSend',
      data,
    })
  },
}
